<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div class="flex justify-center px-4">
      <div
        class="tablet relative flex flex-col items-start rounded bg-white p-8"
      >
        <img
          class="absolute right-4 top-4 h-4 w-4 cursor-pointer"
          src="@/assets/close-icon.svg"
          alt="cose icon"
          @click="$emit('close')"
        />

        <h3 class="mb-4 text-3xl text-dark-blue">Report an Error</h3>
        <p class="mb-4 text-left text-body-color">
          Please let us know if you find an error in our data.
        </p>

        <p class="mb-1 text-xxs font-bold uppercase text-dark-blue">
          What Error was found?
        </p>
        <textarea
          id="text-area"
          v-model="message"
          placeholder="Describe the error(s) in as much detail as possible to help us identify and correct it"
          class="mb-4 h-32 w-full rounded-md border border-transparent bg-off-white p-2 text-sm text-dark-gray hover:border-placeholder-gray focus:bg-white"
        />
        <span
          class="w-full md:ml-auto md:flex md:w-2/3 md:flex-row-reverse md:gap-x-2"
        >
          <button-main
            v-if="isTablet"
            :disabled="!message"
            @click="onToast(message)"
            >Submit</button-main
          >
          <button-main
            v-if="!isTablet"
            :disabled="!message"
            @click="onSuccess(message)"
            >Submit</button-main
          >
          <button-main
            variant="secondary"
            class="mt-3 md:mt-0"
            @click="$emit('close')"
            >Cancel</button-main
          >
        </span>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';
import { ref } from 'vue';
import { useStore } from 'vuex';

export default {
  name: 'ErrorReportModal',
  components: {
    Modal,
    ButtonMain,
  },
  props: {
    visible: Boolean,
    stepName: String,
  },
  emits: ['close', 'success', 'toast'],
  setup(_, { emit }) {
    const store = useStore();
    const carrier_id = store.state.carriers.carrierDetails.id;

    const sendError = (message) => {
      let payload = {
        message,
        carrier_id,
      };
      store.dispatch('editRequest/createEditRequest', payload);
    };

    const onCancel = () => {
      emit('close');
    };

    const onSuccess = (message) => {
      // console.log("Error report message::", message);
      sendError(message);
      emit('success');
    };

    const onToast = (message) => {
      sendError(message);
      emit('toast');
    };

    return {
      onCancel,
      onSuccess,
      onToast,
      sendError,
    };
  },
  data() {
    return {
      message: '',
    };
  },
  computed: {
    isTablet() {
      let width = ref(window.innerWidth);
      if (width.value > 768) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    const textArea = document.querySelector(`#text-area`);
    textArea.focus();
  },
};
</script>

<style scoped>
@media (min-width: 768px) {
  .tablet {
    width: 500px;
  }
}
</style>
